import { extendTheme } from '@chakra-ui/react';


const theme = extendTheme({
  colors: {
    brand: {
      50: '#f7fafc',
      100: '#edf2f7',
      200: '#e2e8f0',
      300: '#cbd5e0',
      400: '#a0aec0',
      500: '#718096',
      600: '#4a5568',
      700: '#2d3748',
      800: '#1a202c',
      900: '#171923',
    },
    accent: {
      500: '#FFD700', // Dourado para elementos de destaque
    },
  },
  fonts: {
    heading: 'system-ui, sans-serif',
    body: 'system-ui, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'black',
        color: 'white',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'md',
      },
      variants: {
        primary: {
          bg: 'accent.500',
          color: 'black',
          _hover: {
            bg: 'yellow.400',
          },
        },
        outline: {
          border: '2px solid',
          borderColor: 'white',
          color: 'white',
        },
        ghost: {
          color: 'white',
          _hover: {
            bg: 'whiteAlpha.200',
          },
        },
      },
      defaultProps: {
        variant: 'primary',
      },
    },
    Heading: {
      baseStyle: {
        color: 'white',
        fontWeight: 'bold',
      },
    },
    Text: {
      baseStyle: {
        color: 'white',
      },
    },
    Card: {
      baseStyle: {
        bg: 'gray.800',
        borderRadius: 'md',
      },
    },
  },
});

export default theme;
